var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetanque({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "a",
    cx: 37.074,
    cy: 28.072,
    rx: 9.047,
    ry: 9.035
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB5556",
    d: "M20.477 16.491c2.177 1.787 5.141 3.167 8.562 3.93-1.555 1.629-2.62 3.729-2.954 6.064-3.047-2.38-5.139-5.925-5.603-9.965l-.005-.029Zm29.477.002c-.295 2.614-1.272 5.021-2.748 7.042-.684-1.523-1.702-2.863-2.961-3.928 2.22-.783 4.163-1.846 5.71-3.114Zm-14.737-16.493c7.783 0 14.166 5.987 14.783 13.601-1.699 1.972-4.503 3.604-7.966 4.55-1.493-.747-3.178-1.167-4.96-1.167-2.197 0-4.245.638-5.97 1.738-.127-.017-.253-.038-.379-.059-1.611-4.543-4.986-7.984-9.096-9.799 2.294-5.219 7.514-8.864 13.588-8.864Zm-14.283 10.803c3.171 1.438 5.83 3.982 7.36 7.318-3.414-.949-6.178-2.567-7.86-4.517.075-.938.238-1.85.48-2.73l.02-.07Zm14.283-8.532c-4.997 0-9.047 2.574-9.047 5.749 0 3.175 4.05 5.749 9.047 5.749 4.996 0 9.046-2.574 9.046-5.75 0-3.174-4.05-5.748-9.046-5.748Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M49.944 16.52c-.302 2.594-1.278 4.984-2.749 6.99l-.03-.067c-.046-.1-.093-.199-.142-.297l.172.363c-.068-.151-.14-.301-.216-.45-.049-.096-.1-.193-.152-.288-.012-.022-.024-.045-.037-.067-.058-.105-.117-.208-.179-.31-.016-.028-.032-.055-.049-.082-.136-.223-.28-.442-.432-.655-.013-.019-.027-.038-.04-.057-.073-.1-.147-.199-.222-.296-.022-.028-.044-.057-.066-.085-.157-.199-.32-.392-.49-.579-.02-.023-.04-.045-.061-.068-.082-.09-.166-.177-.25-.263l-.02-.02c.191-.387.362-.775.513-1.164 1.646-.688 3.11-1.538 4.335-2.514l.115-.092Zm-14.684-16.489c7.775 0 14.147 5.993 14.739 13.605-.947 1.084-2.229 2.063-3.77 2.88.661-3.724-.318-7.362-2.378-10.32-.28-.54-.683-1.043-1.187-1.498-1.936-2.158-4.5-3.815-7.404-4.667Z",
    opacity: 0.301
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "M18.638 23.623c2.172 6.677.288 13.218-3.903 15.508-6.215-.042-11.98-4.012-14.005-10.239-1.753-5.387-.248-11.05 3.43-14.864.299-.147.609-.274.929-.378 5.008-1.625 11.18 2.694 13.549 9.973Zm10.305-3.886c.064.199.124.397.18.597-1.95 1.998-3.15 4.727-3.15 7.738 0 1.679.373 3.27 1.042 4.697-1.782 2.567-4.39 4.593-7.595 5.633-.316.103-.632.194-.948.274 3.086-3.625 4.076-9.676 2.12-15.687-2.213-6.802-7.507-11.431-12.785-11.721.769-.412 1.586-.762 2.446-1.041 7.79-2.528 16.158 1.73 18.69 9.51Zm-23.371-1.916c-3.024.981-4.223 5.624-2.68 10.37 1.36 4.175 4.39 7.04 7.158 6.998l.188-.007c.313-.02.623-.078.925-.176 3.024-.981 4.223-5.623 2.68-10.369-1.329-4.08-4.253-6.91-6.97-6.997l-.188-.002c-.378.006-.75.066-1.113.183Zm24.037 5.146c.234 2.524-.194 5.016-1.173 7.26l-.095.21c-.205-.754-.314-1.547-.314-2.365 0-1.895.584-3.653 1.582-5.105Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#EDEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M37.074 19.037c-4.996 0-9.047 4.045-9.047 9.035 0 4.99 4.05 9.034 9.047 9.034 4.996 0 9.046-4.045 9.046-9.034 0-4.99-4.05-9.035-9.046-9.035Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M40.46 36.446c4.633-1.87 6.87-7.135 5-11.761.911 8.534-11.51 14.106-16.776 6.769 1.871 4.626 7.144 6.861 11.776 4.992Z",
    opacity: 0.315
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "M10.881 25.976c-.856-2.633-2.91-4.326-4.588-3.782-1.677.545-2.343 3.12-1.486 5.753.856 2.633 2.91 4.326 4.588 3.781 1.677-.544 2.343-3.12 1.486-5.752Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB5556",
    d: "M38.12 6.315c-.856-2.636-2.908-4.332-4.584-3.787-1.675.544-2.339 3.122-1.482 5.759.857 2.636 2.909 4.332 4.584 3.787 1.676-.544 2.34-3.122 1.483-5.759Z",
    transform: "rotate(-72 35.087 7.301)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetanque);
export default __webpack_public_path__ + "static/media/petanque.7dbaa1b8b5ee7992357f44fb34db88fa.svg";
export { ForwardRef as ReactComponent };